import { LocalStorageKeys } from "src/app/core/enums/LocalStorageKeys";
import { SummaryData } from "src/app/pages/new-service/interfaces/SummaryData";
import { LocalStorageService } from "src/app/services/local-storage.service";





export function normalizeText(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}

export function scrollToElement(parentId: string, childId: string): void {
    const parentElement = document.getElementById(parentId);
    const childElement = document.getElementById(childId);

    if (parentElement && childElement) {
        const parentRect = parentElement.getBoundingClientRect();
        const childRect = childElement.getBoundingClientRect();

        const offset = childRect.top - parentRect.top + parentElement.scrollTop;

        parentElement.scrollTo({
            top: offset,
            behavior: 'smooth'
        });
    } else {
        console.warn('No se encontraron los elementos con los IDs proporcionados.');
    }
}


export function deepEqual(a: any, b: any): boolean {
    try {
        return JSON.stringify(a) === JSON.stringify(b);
    } catch {
        return false;
    }
}

export function generarCSVBlob(
    columnas: { key: string; label: string }[],
    datos: any[]
): Blob {

    const encabezados = columnas.map(c => c.label).join(';') + '\n';

    const filas = datos.map(fila =>
        columnas.map(col => {
            const valor = fila[col.key] ?? '';
            return `"${String(valor).replace(/"/g, '""')}"`;
        }).join(';')
    ).join('\n');

    const contenidoCSV = encabezados + filas;
    return new Blob([contenidoCSV], { type: 'text/csv;charset=utf-8;' });
}

export function countryIso3ToLocale(iso3: string): string {
    const map: Record<string, string> = {
        GBR: 'en-UK',
        ESP: 'es-ES',
        FRA: 'fr-FR',
        USA: 'en-US',
        DEU: 'de-DE',
        ITA: 'it-IT',
        PRT: 'pt-PT',
        CHL: 'es-CL'
    };

    return map[iso3.toUpperCase()] ?? 'es-ES';
}